// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestsCard-cls1_a9o","cls2":"ResearchInterestsCard-cls2_EQz ResearchInterestsCard-cls1_a9o"};